import { CommonModule } from '@angular/common';
import { Component, DestroyRef, ElementRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InfomodalComponent } from '@app/components/modals/infomodal/infomodal.component';
import { ModalsModule } from '@app/components/modals/modals.module';
import { AcvisService } from '@app/services/acvis.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { MediaService } from '@app/services/media.service';
import { UiOfferService } from '@app/services/uioffer.service';
import { AngularMaterialModule } from "@app/material.module";

@Component({
    selector: 'clever-bosysbooking',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatDivider,
        ModalsModule,
        MatButtonToggleModule,
        AngularMaterialModule
    ],
    templateUrl: './bosysbooking.html',
    styleUrl: './bosysbooking.scss'
})
export class Bosysbooking implements OnInit {

    offer = input<any>(null);
    form = input<any>(null);
    person = input<any>(null);

    CrossMw = signal<boolean>(false);
    CrossVers = signal<boolean>(false);
    ReadPRRL = signal<boolean>(false);
    ReadAGBRB = signal<boolean>(false);
    ReadAGBVA = signal<boolean>(false);
    ReadTRV = signal<boolean>(false);

    paramschecked = signal<boolean>(false);
    loadingbooking = signal<boolean>(false);
    bookingsucces = signal<boolean>(false);
    bookingsendet = signal<boolean>(false);

    Remark: string = '';

    as_same = signal<boolean>(false);

    countryList = signal<any[]>([]);

    geburtstagdata = signal<string[]>([]);
    monatdata = signal<string[]>([]);
    jahrdata = signal<string[]>([]);
    travelers = signal<any[]>([]);

    travelersForm: FormGroup;
    profileForm: FormGroup;

    countryName: string = '';
    destroyRef = inject(DestroyRef);

    AdditionalSerices: any[] = [];
    traveler: any[] = [];
    customer: any;
    Zusatz: any = {
        CrossMW: 'N',
        CrossVers: 'N',
        ReadPRRL: 'N',
        ReadAGBRB: 'N',
        ReadAGBVA: 'N',
        ReadTRV: 'N',
        Payment: '',
        Remark: ''
    };

    constructor(
        protected fb: FormBuilder,
        protected mediaServise: MediaService,
        protected dialog: MatDialog,
        protected uiOfferService: UiOfferService,
        protected acvisService: AcvisService,
        protected guard: AuthGuardService,
        protected el: ElementRef
    ) { }

    ngOnInit(): void {
        // console.log(this.offer());
        this.initdaten();
        // this.getCountrys();
    }

    async getCountrys() {
        this.acvisService.request({}, 'country').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            if (res?.length > 0) {
                this.countryList.set(res);
                for (let i = 0; i < this.countryList()?.length; i++) {
                    this.countryList()[i].code = this.countryList()[i].code.toUpperCase();
                }
                this.countryList()?.sort((a, b) => a.name.localeCompare(b.name));
            }
        });
    }

    async initdaten() {
        for (let i = 0; i < 31; i++) {
            this.geburtstagdata().push(('00' + (i + 1)).slice(-2));
        }

        for (let i = 0; i < 12; i++) {
            this.monatdata().push(('00' + (i + 1)).slice(-2));
        }

        for (let i = new Date().getFullYear(); i > 1919; i--) {
            this.jahrdata().push(i + '');
        }

        this.travelersForm = this.fb.group({});
        this.profileForm = this.fb.group({
            // anmelder_salutation: new FormControl('', [Validators.required, Validators.minLength(1)]),
            // anmelder_firstname: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_lastname: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_strasse: new FormControl('', [Validators.required, Validators.minLength(3)]),
            // anmelder_hausnummer: new FormControl('', [Validators.required, Validators.minLength(1)]),
            // anmelder_plz: new FormControl('', [Validators.required, Validators.minLength(5)]),
            // anmelder_wohnort: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_land: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_telefon: new FormControl('', [Validators.required, Validators.minLength(5)]),
            // anmelder_email: new FormControl('', [Validators.required, Validators.email]),
            // anmelder_monat: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_jahr: new FormControl('', [Validators.required, Validators.minLength(2)]),
            // anmelder_geburtstag: new FormControl('', [Validators.required, Validators.minLength(2)]),

            anmelder_salutation: new FormControl('H', [Validators.required, Validators.minLength(1)]),
            anmelder_firstname: new FormControl('Test', [Validators.required, Validators.minLength(2)]),
            anmelder_lastname: new FormControl('Test', [Validators.required, Validators.minLength(2)]),
            anmelder_strasse: new FormControl('Test str', [Validators.required, Validators.minLength(3)]),
            anmelder_hausnummer: new FormControl('9', [Validators.required, Validators.minLength(1)]),
            anmelder_plz: new FormControl('99999', [Validators.required, Validators.minLength(5)]),
            anmelder_wohnort: new FormControl('Test', [Validators.required, Validators.minLength(2)]),
            anmelder_land: new FormControl('DE', [Validators.required, Validators.minLength(2)]),
            anmelder_telefon: new FormControl('999999999999', [Validators.required, Validators.minLength(5)]),
            anmelder_email: new FormControl('test@test.com', [Validators.required, Validators.email]),
            anmelder_monat: new FormControl('01', [Validators.required, Validators.minLength(2)]),
            anmelder_jahr: new FormControl('1990', [Validators.required, Validators.minLength(2)]),
            anmelder_geburtstag: new FormControl('01', [Validators.required, Validators.minLength(2)]),
        });
        let count = 0;
        if (this.offer()?.pax_adu > 0) {
            for (let i = 0; i < this.offer()?.pax_adu; i++) {
                this.travelers().push({
                    Salutation: 'H'
                });
                count++;
                this.travelersForm.addControl((count) + '_nationality', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_salutation', new FormControl('', [Validators.required, Validators.minLength(1)]));
                this.travelersForm.addControl((count) + '_lastname', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_firstname', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_monat', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_jahr', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_geburtstag', new FormControl('', [Validators.required, Validators.minLength(2)]));
            }
            for (let i = 0; i < (this.offer()?.pax_chd + this.offer()?.pax_inf); i++) {
                this.travelers().push({
                    Salutation: 'K'
                });
                count++;
                this.travelersForm.addControl((count) + '_nationality', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_salutation', new FormControl('', [Validators.required, Validators.minLength(1)]));
                this.travelersForm.addControl((count) + '_lastname', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_firstname', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_monat', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_jahr', new FormControl('', [Validators.required, Validators.minLength(2)]));
                this.travelersForm.addControl((count) + '_geburtstag', new FormControl('', [Validators.required, Validators.minLength(2)]));
            }
        }
    }

    setDisabled(): void {
        this.as_same.set(!this.as_same());
        if (this.as_same()) {
            this.travelersForm.controls['1_salutation'].setValue(this.profileForm.controls['anmelder_salutation'].value);
            this.travelersForm.controls['1_salutation'].disable();
            this.travelersForm.controls['1_firstname'].setValue(this.profileForm.controls['anmelder_firstname'].value);
            this.travelersForm.controls['1_firstname'].disable();
            this.travelersForm.controls['1_lastname'].setValue(this.profileForm.controls['anmelder_lastname'].value);
            this.travelersForm.controls['1_lastname'].disable();
            this.travelersForm.controls['1_monat'].setValue(this.profileForm.controls['anmelder_monat'].value);
            this.travelersForm.controls['1_monat'].disable();
            this.travelersForm.controls['1_jahr'].setValue(this.profileForm.controls['anmelder_jahr'].value);
            this.travelersForm.controls['1_jahr'].disable();
            this.travelersForm.controls['1_geburtstag'].setValue(this.profileForm.controls['anmelder_geburtstag'].value);
            this.travelersForm.controls['1_geburtstag'].disable();
        } else {
            this.travelersForm.controls['1_salutation'].enable();
            this.travelersForm.controls['1_firstname'].enable();
            this.travelersForm.controls['1_lastname'].enable();
            this.travelersForm.controls['1_monat'].enable();
            this.travelersForm.controls['1_jahr'].enable();
            this.travelersForm.controls['1_geburtstag'].enable();
        }
    }

    // changeCountry(ev): void {
    //     this.countryName = '';
    //     for (let i = 0; i < this.countryList?.length; i++) {
    //         if (this.countryList[i].code === ev.value) {
    //             this.countryName = this.countryList[i].name;
    //             i = this.countryList.length;
    //         }
    //     }
    // }

    async openInfo(info, title, ev) {
        ev.stopPropagation();
        this.dialog.open(InfomodalComponent, {
            width: this.mediaServise.media() !== 'xs' ? '800px' : '100%',
            height: this.mediaServise.media() !== 'xs' ? '' : '100vh',
            maxWidth: '100%',
            autoFocus: false,
            panelClass: 'customModal',
            data: { message: info, title: title }
        });
    }

    async checkSaises() {
        // console.log(this.profileForm.valid);
        // console.log(this.travelersForm);
        // console.log(this.travelersForm.valid);
        this.loadingbooking.set(true);
        this.traveler = [];
        this.paramschecked.set(true);
        if (this.travelersForm.valid && this.profileForm.valid &&
            (!this.ReadPRRL() || (this.form()?.offer?.PRRL && this.ReadPRRL())) &&
            (!this.ReadTRV() || (this.form()?.offer?.entry_requirements && this.ReadTRV())) &&
            (!this.ReadAGBRB() || (this.form()?.offer?.agb_office && this.ReadAGBRB())) &&
            (!this.ReadPRRL() || (this.form()?.offer?.agb_operator && this.ReadAGBVA()))
        ) {
            this.customer = {
                Anrede: this.profileForm.controls['anmelder_salutation'].value,
                Vorname: this.profileForm.controls['anmelder_firstname'].value,
                name: this.profileForm.controls['anmelder_lastname'].value,
                street: this.profileForm.controls['anmelder_strasse'].value + ' ' + this.profileForm.controls['anmelder_hausnummer'].value,
                code: this.profileForm.controls['anmelder_plz'].value,
                city: this.profileForm.controls['anmelder_wohnort'].value,
                land: this.profileForm.controls['anmelder_land'].value,
                phone: this.profileForm.controls['anmelder_telefon'].value,
                mail: this.profileForm.controls['anmelder_email'].value,
            };

            for (let j = 0; j < this.travelers().length; j++) {
                this.traveler.push(
                    {
                        nation: this.travelersForm.controls[(j + 1) + '_nationality'].value,
                        Anrede: this.travelersForm.controls[(j + 1) + '_salutation'].value,
                        Vorname: this.travelersForm.controls[(j + 1) + '_firstname'].value,
                        name: this.travelersForm.controls[(j + 1) + '_lastname'].value,
                        birthday: this.travelersForm.controls[(j + 1) + '_jahr'].value + '-' + this.travelersForm.controls[(j + 1) + '_monat'].value + '-' + this.travelersForm.controls[(j + 1) + '_geburtstag'].value,
                        // traveler_nationalityCountryName: this.getCountryNameFromCode(this.travelersForm.controls[(j + 1) + '_nationality'].value)
                    }
                );
            }

            this.Zusatz = {
                CrossMW: this.CrossMw() ? 'J' : 'N',
                CrossVers: this.CrossVers() ? 'J' : 'N',
                ReadPRRL: this.ReadPRRL() ? 'J' : 'N',
                ReadAGBRB: this.ReadAGBRB() ? 'J' : 'N',
                ReadAGBVA: this.ReadAGBVA() ? 'J' : 'N',
                ReadTRV: this.ReadTRV() ? 'J' : 'N',
                Payment: '',
                Remark: this.Remark
            }

            // console.log(this.customer);
            // console.log(this.traveler);
            this.sendBooking();
        } else {
            this.travelersForm.markAllAsTouched();
            this.profileForm.markAllAsTouched();
            this.loadingbooking.set(false);
            setTimeout(() => {
                this.goToError();
            }, 100);
        }
    }

    async goToError() {
        const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid');
        if (invalidElements.length > 0) {
            invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    }

    async sendBooking() {
        this.AdditionalSerices = [];
        for (let i = 0; i < this.offer()?.AdditionalServices?.length; i++) {
            if(this.offer()?.AdditionalServices[i]?.active) {
                this.AdditionalSerices.push({
                    id: this.offer()?.AdditionalServices[i].id
                })
            }
        }
        const target = {
            token: this.offer().offerID,
            recid: String(this.offer().recID),
            customer: this.customer,
            traveler: this.traveler,
            Zusatz: this.Zusatz,
            AdditionalSerices: this.AdditionalSerices,
            partnerid: this.guard.getPartnerId()
        }
        // console.log(target);
        this.uiOfferService.request(target, 'putBookingRequest').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(result => {
            // console.log(result);
            this.bookingsendet.set(true);
            this.bookingsucces.set(result?.bns_response?.OK.Status === 0);
            this.loadingbooking.set(false);
        });
    }
}
